export default defineNuxtPlugin({
    name: 'settings',
    dependsOn: ['axios'],
    async setup(nuxtApp)
    {
        return {
            provide: {
                settings: (name: string, throwError: boolean = false) =>
                {
                    return useSettingsStore().$settings(name, throwError);
                }
            }
        };
    }
});

declare module '@vue/runtime-core'
{
    interface ComponentCustomProperties
    {
        $settings(name: string, throwError?: boolean): Promise<any>;
    }
}
